(function () {
  var desktop = window.matchMedia('(min-width: 750px)');
  var closedHeight = 0;

  function getColumn() {
    return document.querySelector('body.template-suffix-v2 .product-information .product-details');
  }

  function update() {
    var column = getColumn();
    var block = column && column.querySelector(':scope > .group-block');
    if (!block || !desktop.matches) {
      document.body.style.removeProperty('--nr-quiet-offset');
      return;
    }

    if (!block.querySelector('.accordion details[open]') || !closedHeight) {
      closedHeight = block.offsetHeight;
    }

    var styles = getComputedStyle(column);
    var available = column.clientHeight - parseFloat(styles.paddingTop) - parseFloat(styles.paddingBottom);
    var offset = Math.max(0, (available - closedHeight) / 2);
    document.body.style.setProperty('--nr-quiet-offset', offset + 'px');
  }

  function initCarets() {
    if (!document.body.classList.contains('template-suffix-v2')) return;
    var root = document.querySelector('.product-information slideshow-component');
    if (!root || root.dataset.nrCarets) return;
    var slides = root.querySelectorAll('slideshow-slide');
    if (slides.length < 2) return;
    root.dataset.nrCarets = 'true';

    function caret(className, label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'nr-gallery-caret ' + className;
      button.setAttribute('aria-label', label);
      root.appendChild(button);
      return button;
    }

    var prev = caret('nr-gallery-caret--prev', 'Previous image');
    var next = caret('nr-gallery-caret--next', 'Next image');

    function sync() {
      var current = 0;
      slides.forEach(function (slide, index) {
        if (slide.getAttribute('aria-hidden') === 'false') current = index;
      });
      prev.hidden = current <= 0;
      next.hidden = current >= slides.length - 1;
    }

    prev.addEventListener('click', function (event) {
      event.preventDefault();
      if (typeof root.previous === 'function') root.previous(event);
    });
    next.addEventListener('click', function (event) {
      event.preventDefault();
      if (typeof root.next === 'function') root.next(event);
    });

    var observer = new MutationObserver(sync);
    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
    sync();
  }

  function init() {
    update();
    initCarets();
    window.addEventListener('resize', update);
    desktop.addEventListener('change', update);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
